import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const pagesSiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'pages'

export const config = {
	site: pagesSiteConfig,
	reactRendererSite: pagesSiteConfig,
	reactNativeSite: pagesSiteConfig,
	name,
}
